// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"170":"forum","173":"wiki-tools","284":"data-table","566":"view-account","569":"view-secondary","660":"yeti"}[chunkId] + "." + {"170":"df04bf68","173":"3b68298c","284":"7a2dd8d5","566":"efe95682","569":"09103240","660":"8ac071b3"}[chunkId] + ".css";
};